import { render, staticRenderFns } from "./loginPhone.vue?vue&type=template&id=19456374&scoped=true&"
import script from "./loginPhone.vue?vue&type=script&lang=js&"
export * from "./loginPhone.vue?vue&type=script&lang=js&"
import style0 from "./loginPhone.vue?vue&type=style&index=0&id=19456374&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19456374",
  null
  
)

export default component.exports